import { Autocomplete, TextField } from '@mui/material';
import { useMap } from 'react-leaflet';

export interface NapOption {
  id: string | number;
  nombre: string;
  ciudad?: string;
  lat: number;
  lng: number;
}

interface NapsSearchControlProps {
  naps: NapOption[];
  onSelect: (nap: NapOption) => void;
}

const normalize = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const NapsSearchControl: React.FC<NapsSearchControlProps> = ({ naps, onSelect }) => {
  const map = useMap();

  const handleChange = (_event: any, value: NapOption | null) => {
    if (!value) return;
    map.flyTo([value.lat, value.lng], 18);
    onSelect(value);
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        width: 340,
      }}
    >
      <Autocomplete
        options={naps}
        getOptionLabel={(option) => option.nombre}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            variant="outlined"
            label="Buscar NAP"
            sx={{ bgcolor: 'background.paper' }}
          />
        )}
        filterOptions={(options, state) => {
          const term = normalize(state.inputValue);
          if (!term) return options.slice(0, 50);
          return options.filter((option) => normalize(option.nombre).includes(term)).slice(0, 100);
        }}
      />
    </div>
  );
};

export default NapsSearchControl;